import { FormGroupUI } from "components/FormGroup";
import { FormGroupLabelUI } from "components/FormGroupLabel";
import { RhfCreatableMultiSelect } from "components/rhfs/RhfCreatableMultiSelect";
import { RhfFromToNumberInput } from "components/rhfs/RhfFromToNumberInput";
import { RhfFromToRange } from "components/rhfs/RhfFromToRange";
import { RhfRadioGroup } from "components/rhfs/RhfRadioGroup";
import { RhfSelect } from "components/rhfs/RhfSelect";
import { RhfSkillAutocomplete } from "components/rhfs/RhfSkillAutocomplete";
import { RhfToggle } from "components/rhfs/RhfToggle";
import {
  hrOrderTypeOptions,
  INITIAL_HR_FILTER,
  limitedDaysOptions,
} from "constants/search-fiilter";
import { type EmailSearchInput, GenderType } from "hooks/useEmailsRestApi";
import type { FC } from "react";
import type { OptionItem } from "types/common";

export type ChangeEmailSearchInput = (searchInput: EmailSearchInput) => void;
export type ChangeIsMatterHandler = (isMatter: boolean) => void;

const genders: OptionItem[] = [
  {
    label: "男性",
    value: GenderType.Male,
  },
  {
    label: "女性",
    value: GenderType.Female,
  },
];

export const HRTypeFormUI: FC = () => {
  return (
    <div className="flex flex-col w-full">
      {/* 左側 */}
      <div className="flex flex-col grow">
        <FormGroupUI className="mb-6">
          <FormGroupLabelUI>期間</FormGroupLabelUI>
          <RhfSelect
            name="limitedByDay"
            width="narrow"
            options={limitedDaysOptions}
          />
        </FormGroupUI>
        {/* 単価 */}
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>単価</FormGroupLabelUI>
          <RhfFromToNumberInput
            testLabel="hr-reward"
            nameFrom="hrFilter.rewardRange.from"
            nameTo="hrFilter.rewardRange.to"
            min={INITIAL_HR_FILTER.rewardRange!.from!}
            max={INITIAL_HR_FILTER.rewardRange!.to!}
            step={5}
            unitName="万円"
          />
        </FormGroupUI>
        {/* 男性 OR 女性 */}
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>性別</FormGroupLabelUI>
          <RhfRadioGroup name="hrFilter.genderType" options={genders} />
        </FormGroupUI>
      </div>
      <div className="divider divider-horizontal"></div>
      {/* 中央 */}
      <div className="flex flex-col grow">
        <FormGroupUI className="mb-6">
          <FormGroupLabelUI>並び順</FormGroupLabelUI>
          <RhfSelect
            name="orderType"
            width="narrow"
            options={hrOrderTypeOptions}
          />
        </FormGroupUI>
        {/* 年齢 */}
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>年齢</FormGroupLabelUI>
          <RhfFromToRange
            testLabel="hr-age"
            nameFrom="hrFilter.ageRange.from"
            nameTo="hrFilter.ageRange.to"
            min={INITIAL_HR_FILTER.ageRange!.from!}
            max={INITIAL_HR_FILTER.ageRange!.to!}
            step={1}
            size="xs"
            unitName="歳"
          />
        </FormGroupUI>
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>スキル</FormGroupLabelUI>
          <RhfSkillAutocomplete
            name="skills"
            placeholder="例: TypeScript, AWS"
          />
        </FormGroupUI>
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>フリーワード</FormGroupLabelUI>
          <RhfCreatableMultiSelect
            name="freeWords"
            placeholder="例: 会社名, 駅名"
          />
        </FormGroupUI>
      </div>
      <div className="divider divider-horizontal"></div>
      {/* 右側 */}
      <div className="flex flex-col grow-0 w-full space-y-2.5">
        <RhfToggle
          color="primary"
          label="正社員"
          name="hrFilter.hrTypes.fullTimeEmployee"
        />
        <RhfToggle
          color="primary"
          label="フリーランス"
          name="hrFilter.hrTypes.freerance"
        />
        <RhfToggle
          color="primary"
          label="契約社員"
          name="hrFilter.hrTypes.contractEmployee"
        />
        <RhfToggle
          color="primary"
          label="直属のみ"
          name="hrFilter.immediately"
        />
        <RhfToggle
          color="primary"
          label="リモート希望"
          name="hrFilter.needRemote"
        />
        <RhfToggle
          color="primary"
          label="日本籍のみ"
          name="hrFilter.onlyJapanese"
        />
        <RhfToggle
          color="warning"
          label="お気に入りのみ"
          name="favoritesOnly"
        />
      </div>
    </div>
  );
};
